import { ws } from "../../../utils/common";

export const subscriptionShiftWS = async ({ id_shift }) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "user-shift/" + id_shift,
    null,
    { notification: true },
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const removeUserSubscritpionWS = async ({ id_shift }) => {
  const res = await ws(
    "DELETE",
    process.env.REACT_APP_ENDPOINT + "user-shift/" + id_shift,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};
